import * as React from "react";

export default class NotFound extends React.Component {

    render() {
        return "Not Found"
    }
}